import React from 'react';
import { motion } from 'framer-motion';
import { Award, Layers, MapPin, UserCheck } from 'lucide-react';
export function About() {
  const stats = [{
    value: '20+',
    label: 'Years of Experience',
    description: "Principals' combined industry expertise.",
    Icon: Award
  }, {
    value: 'Full-Service',
    label: 'Recovery Coverage',
    description: 'Every stage of delinquency, end to end.',
    Icon: Layers
  }, {
    value: 'NY-Based',
    label: 'Locally Operated',
    description: 'Headquartered in Depew, New York.',
    Icon: MapPin
  }, {
    value: 'Principal-Led',
    label: 'Personal Attention',
    description: 'Direct senior involvement on every account.',
    Icon: UserCheck
  }];
  return <section id="about" className="py-24 bg-white" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-24">
          {/* Stats Panel */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative rounded-2xl bg-brand-navy p-6 sm:p-8" data-id="element-25">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-26">
              {stats.map(({
              value,
              label,
              description,
              Icon
            }) => <div key={label} className="relative bg-white rounded-xl p-5 shadow-sm flex flex-col justify-between min-h-[160px]" data-id="element-27">
                  <Icon size={20} className="absolute top-4 right-4 text-brand-red" data-id="element-28" />
                  <p className="text-2xl sm:text-3xl font-bold text-brand-navy leading-tight pr-8" data-id="element-29">
                    {value}
                  </p>
                  <div className="mt-4" data-id="element-30">
                    <p className="text-[11px] font-bold tracking-wider text-brand-muted uppercase mb-1" data-id="element-31">
                      {label}
                    </p>
                    <p className="text-sm text-brand-dark/70 leading-snug" data-id="element-32">
                      {description}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-33">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6" data-id="element-34">
              About Compass Recovery Group
            </h2>
            <div className="space-y-6 text-lg text-brand-muted leading-relaxed" data-id="element-35">
              <p data-id="element-36">
                Compass Recovery Group, LLC is a professional Receivables &
                Collections Management Firm located in Depew, NY. We were
                founded on a simple premise: debt collection doesn't have to
                come at the expense of customer relationships.
              </p>
              <p data-id="element-37">
                With Principals having over 20 years of industry experience, we
                bring deep institutional knowledge to every account we handle.
                We are intentionally a small collection agency, which allows us
                to be agile, responsive, and deeply dedicated to Quality
                Customer Care.
              </p>
              <p data-id="element-38">
                Whether you are a business looking to improve your bottom line
                or a consumer looking to resolve an outstanding balance, you
                will find our team to be professional, knowledgeable, and
                committed to finding solutions.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}